import { lazy } from "react";
// project import
import Loadable from "components/Loadable";
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| ROUTES ITEMS - DASHBOARD ||============================== //

// render - dashboard
const UnmannedAerialVehiclesDefault = Loadable(
    lazy(() => import("pages/nostradamus/unmanned-aerial-vehicles/UAVPage"))
);

const unmanned_aerial_vehicles = {
    path: "unmanned-aerial-vehicles",
    element: (
        // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
        <UnmannedAerialVehiclesDefault />
        // </RequireAuthorizedAccess>
    ),
};

export default unmanned_aerial_vehicles;
